export const getFieldIds = (id: string) => ({
  inputId: id,
  errorId: `${id}-error`,
  helpId: `${id}-help`,
  describedBy: `${id}-error ${id}-help`,
  labelledBy: `${id}-label`
})
